/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Export_Logs_ButtonInputs */

const en_drastic_tech_export_logs_button = /** @type {(inputs: Drastic_Tech_Export_Logs_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Logs...`)
};

const fr_drastic_tech_export_logs_button = /** @type {(inputs: Drastic_Tech_Export_Logs_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter les journaux...`)
};

const de_drastic_tech_export_logs_button = /** @type {(inputs: Drastic_Tech_Export_Logs_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportprotokolle...`)
};

const it_drastic_tech_export_logs_button = /** @type {(inputs: Drastic_Tech_Export_Logs_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta registri...`)
};

const ru_drastic_tech_export_logs_button = /** @type {(inputs: Drastic_Tech_Export_Logs_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Журналы экспорта...`)
};

const es_drastic_tech_export_logs_button = /** @type {(inputs: Drastic_Tech_Export_Logs_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar registros...`)
};

const zh_cn2_drastic_tech_export_logs_button = /** @type {(inputs: Drastic_Tech_Export_Logs_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出日志...`)
};

const ja_drastic_tech_export_logs_button = /** @type {(inputs: Drastic_Tech_Export_Logs_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログをエクスポート...`)
};

const hi_drastic_tech_export_logs_button = /** @type {(inputs: Drastic_Tech_Export_Logs_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लॉग निर्यात करें...`)
};

const pt_pt2_drastic_tech_export_logs_button = /** @type {(inputs: Drastic_Tech_Export_Logs_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar registros...`)
};

/**
* | output |
* | --- |
* | "Export Logs..." |
*
* @param {Drastic_Tech_Export_Logs_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_export_logs_button = /** @type {((inputs?: Drastic_Tech_Export_Logs_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Export_Logs_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_export_logs_button(inputs)
	if (locale === "de") return de_drastic_tech_export_logs_button(inputs)
	if (locale === "it") return it_drastic_tech_export_logs_button(inputs)
	if (locale === "ru") return ru_drastic_tech_export_logs_button(inputs)
	if (locale === "es") return es_drastic_tech_export_logs_button(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_export_logs_button(inputs)
	if (locale === "ja") return ja_drastic_tech_export_logs_button(inputs)
	if (locale === "hi") return hi_drastic_tech_export_logs_button(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_export_logs_button(inputs)
	return en_drastic_tech_export_logs_button(inputs)
});